export const types = {
  RESET: "RESET",

  // Authorization
  SET_TOKEN: "SET_TOKEN",
  DELETE_TOKEN: "DELETE_TOKEN",
  SET_IS_TOKEN_EXPIRED: "SET_IS_TOKEN_EXPIRED",

  // Salesforce URL to return to
  SET_RETURN_URL: "SET_RETURN_URL",

  // Opportunity
  SET_OPPORTUNITY: "SET_OPPORTUNITY",
  SET_DERIVED_CUSTOMER_GROUP: "SET_DERIVED_CUSTOMER_GROUP",

  // Customer
  SET_CUSTOMER: "SET_CUSTOMER",

  // Loading counter
  INCREASE_LOADING_COUNTER: "INCREASE_LOADING_COUNTER",
  DECREASE_LOADING_COUNTER: "DECREASE_LOADING_COUNTER",

  // Category tree
  SET_CATEGORY_TREE: "SET_CATEGORY_TREE",

  // region Product
  RESET_PRODUCT: "RESET_PRODUCT",
  SET_PRODUCT_QTY: "SET_PRODUCT_QTY",

  SET_PRODUCT_PICKED_OPTION_SELECTIONS: "SET_PRODUCT_PICKED_OPTION_SELECTIONS",
  SET_PRODUCT_AVAILABLE_OPTIONS: "SET_PRODUCT_AVAILABLE_OPTIONS",
  SET_PRODUCT_CUSTOM_ATTRIBUTES: "SET_PRODUCT_CUSTOM_ATTRIBUTES",

  UPDATE_PRODUCT_SELECTION_QTY: "UPDATE_PRODUCT_SELECTION_QTY",
  UPDATE_PRODUCT_SELECTION_TARGET_PRICE:
    "UPDATE_PRODUCT_SELECTION_TARGET_PRICE",
  UPDATE_PRODUCT_SELECTION_FINANCE_TYPE:
    "UPDATE_PRODUCT_SELECTION_FINANCE_TYPE",
  ADD_PRODUCT_SELECTION: "ADD_PRODUCT_SELECTION",
  DELETE_PRODUCT_SELECTION: "DELETE_PRODUCT_SELECTION",

  SET_PRODUCT_SUBSCRIPTION_TARGET_CHARGE_VALUE:
    "SET_PRODUCT_SUBSCRIPTION_TARGET_CHARGE_VALUE",
  SET_PRODUCT_SUBSCRIPTION_USER_NUM: "SET_PRODUCT_SUBSCRIPTION_USER_NUM",
  SET_PRODUCT_SUBSCRIPTION_TERM: "SET_PRODUCT_SUBSCRIPTION_TERM",

  SET_PRODUCT_CC_BW: "SET_PRODUCT_CC_BW",
  SET_PRODUCT_CC_COLOUR: "SET_PRODUCT_CC_COLOUR",
  SET_PRODUCT_SCAN_CHARGE: "SET_PRODUCT_SCAN_CHARGE",

  SET_PRODUCT_DEFAULT_CC_BW: "SET_PRODUCT_DEFAULT_CC_BW",
  SET_PRODUCT_DEFAULT_CC_COLOUR: "SET_PRODUCT_DEFAULT",
  SET_PRODUCT_DEFAULT_SCAN_CHARGE: "SET_PRODUCT_DEFAULT_SCAN_CHARGE",

  SET_PRODUCT_USER_CLICK_VOLUME_BW: "SET_PRODUCT_USER_CLICK_VOLUME_BW",
  SET_PRODUCT_USER_CLICK_VOLUME_COLOUR: "SET_PRODUCT_USER_CLICK_VOLUME_COLOUR",

  SET_HAS_FALLBACK_CC_BW: "SET_HAS_FALLBACK_CC_BW",
  SET_HAS_FALLBACK_CC_COLOUR: "SET_HAS_FALLBACK_CC_COLOUR",

  SET_PRODUCT_MSA_METRO_CC_BW: "SET_PRODUCT_MSA_METRO_CC_BW",
  SET_PRODUCT_MSA_METRO_CC_COLOUR: "SET_PRODUCT_MSA_METRO_CC_COLOUR",
  SET_PRODUCT_MSA_REGIONAL_CC_BW: "SET_PRODUCT_MSA_REGIONAL_CC_BW",
  SET_PRODUCT_MSA_REGIONAL_CC_COLOUR: "SET_PRODUCT_MSA_REGIONAL_CC_COLOUR",

  SET_PRODUCT_SCANNING_MONTHLY_CHARGE: "SET_PRODUCT_SCANNING_MONTHLY_CHARGE",
  SET_PRODUCT_DEFAULT_SCANNING_MONTHLY_CHARGE:
    "SET_PRODUCT_DEFAULT_SCANNING_MONTHLY_CHARGE",
  SET_PRODUCT_NZ_SCANNING_MONTHLY_CHARGE:
    "SET_PRODUCT_NZ_SCANNING_MONTHLY_CHARGE",
  SET_PRODUCT_DEFAULT_NZ_SCANNING_MONTHLY_CHARGE:
    "SET_PRODUCT_DEFAULT_NZ_SCANNING_MONTHLY_CHARGE",

  SET_PRODUCT_FLAT_MONTHLY_CHARGE: "SET_PRODUCT_FLAT_MONTHLY_CHARGE",
  SET_PRODUCT_DEFAULT_FLAT_MONTHLY_CHARGE:
    "SET_PRODUCT_DEFAULT_FLAT_MONTHLY_CHARGE",
  SET_PRODUCT_FLAT_MONTHLY_CHARGE_MODIFIABLE:
    "SET_PRODUCT_FLAT_MONTHLY_CHARGE_MODIFIABLE",
  SET_PRODUCT_CAMPAIGN: "SET_PRODUCT_CAMPAIGN",
  ADD_PRODUCT_CAMPAIGN: "ADD_PRODUCT_CAMPAIGN",

  SET_PRODUCT_MSA_TERM: "SET_PRODUCT_MSA_TERM",
  SET_PRODUCT_MSA_DEFAULT_TERM: "SET_PRODUCT_MSA_DEFAULT_TERM",

  SET_PRODUCT_MSA_CFA: "SET_PRODUCT_MSA_CFA",
  SET_PRODUCT_MSA_DEFAULT_CFA: "SET_PRODUCT_MSA_DEFAULT_CFA",

  SET_PRODUCT_MSA_MDS_COST: "SET_PRODUCT_MSA_MDS_COST",
  SET_PRODUCT_MSA_DEFAULT_MDS_COST: "SET_PRODUCT_MSA_DEFAULT_MDS_COST",

  SET_PRODUCT_MSA_PRICE_FLAG: "SET_PRODUCT_MSA_PRICE_FLAG",
  SET_PRODUCT_MSA_PAYABLE_METHOD: "SET_PRODUCT_MSA_PAYABLE_METHOD",
  SET_PRODUCT_MSA_INSTALMENT_FREQUENCY: "SET_PRODUCT_MSA_INSTALMENT_FREQUENCY",

  SET_PRODUCT_MINIMUM_MONTHLY_CHARGE: "SET_PRODUCT_MINIMUM_MONTHLY_CHARGE",
  SET_PRODUCT_DEFAULT_MINIMUM_MONTHLY_CHARGE:
    "SET_PRODUCT_DEFAULT_MINIMUM_MONTHLY_CHARGE",
  SET_PRODUCT_MINIMUM_MONTHLY_CHARGE_MODIFIABLE:
    "SET_PRODUCT_MINIMUM_MONTHLY_CHARGE_MODIFIABLE",

  SET_PRODUCT_TONER_DELIVERY_CHARGE: "SET_PRODUCT_TONER_DELIVERY_CHARGE",
  SET_PRODUCT_DEFAULT_TONER_DELIVERY_CHARGE:
    "SET_PRODUCT_DEFAULT_TONER_DELIVERY_CHARGE",

  SET_PRODUCT_PER_A3_CHARGE: "SET_PRODUCT_PER_A3_CHARGE",
  SET_PRODUCT_DEFAULT_PER_A3_CHARGE: "SET_PRODUCT_DEFAULT_PER_A3_CHARGE",

  SET_PRODUCT_SAAS_FINANCE_TYPE: "SET_PRODUCT_SAAS_FINANCE_TYPE",
  SET_PRODUCT_SAAS_EXISTING_TENANT: "SET_PRODUCT_SAAS_EXISTING_TENANT",
  // endregion

  // region Quote
  SET_QUOTE_ID: "SET_QUOTE_ID",
  SET_QUOTE_NAME: "SET_QUOTE_NAME",
  SET_QUOTE_PRICE_FLAG: "SET_QUOTE_PRICE_FLAG",
  UPDATE_QUOTE_PRICE_FLAG: "UPDATE_QUOTE_PRICE_FLAG",
  SET_VALID_QUOTE_PRICE_FLAG_LIST: "SET_VALID_QUOTE_PRICE_FLAG_LIST",
  SET_QUOTE_IS_PRIMARY: "SET_QUOTE_IS_PRIMARY",

  SET_QUOTE_CUSTOMER_GROUP_CODE: "SET_QUOTE_CUSTOMER_GROUP_CODE",
  SET_QUOTE_CUSTOMER_GROUP_ID: "SET_QUOTE_CUSTOMER_GROUP_ID",

  SET_QUOTE_OPPORTUNITY_TYPE: "SET_QUOTE_OPPORTUNITY_TYPE",
  SET_QUOTE_TENDER_CODE: "SET_QUOTE_TENDER_CODE",

  SET_QUOTE_IS_MSA: "SET_QUOTE_IS_MSA",
  SET_QUOTE_SFDC_CUSTOMER_NUMBER: "SET_QUOTE_SFDC_CUSTOMER_NUMBER",

  SET_QUOTE_TARGET_SOFTWARE_TOTAL: "SET_QUOTE_TARGET_SOFTWARE_TOTAL",
  SET_QUOTE_TARGET_HARDWARE_TOTAL: "SET_QUOTE_TARGET_HARDWARE_TOTAL",
  SET_QUOTE_TARGET_SAAS_TOTAL: "SET_QUOTE_TARGET_SAAS_TOTAL",
  SET_QUOTE_SERVICE_TERM: "SET_QUOTE_SERVICE_TERM",

  // region Quote Finance
  SET_QUOTE_IS_FINANCE_CONFIGURED: "SET_QUOTE_IS_FINANCE_CONFIGURED",
  SET_QUOTE_FINANCE_TYPE: "SET_QUOTE_FINANCE_TYPE",
  SET_QUOTE_FINANCE_SUBTYPE: "SET_QUOTE_FINANCE_SUBTYPE",
  SET_QUOTE_CANON_COPY_PLAN_TYPE: "SET_QUOTE_CANON_COPY_PLAN_TYPE",
  SET_QUOTE_CFA_AMOUNT: "SET_QUOTE_CFA_AMOUNT",
  SET_QUOTE_TOTAL_AMOUNT_FINANCED: "SET_QUOTE_TOTAL_AMOUNT_FINANCED",
  SET_QUOTE_ADJUSTMENT_PERIOD: "SET_QUOTE_ADJUSTMENT_PERIOD",
  SET_QUOTE_CANON_FINANCE_PAYOUT: "SET_QUOTE_CANON_FINANCE_PAYOUT",
  SET_QUOTE_CFA_CC_BW: "SET_QUOTE_CFA_CC_BW",
  SET_QUOTE_CFA_CC_BW_ADJUST_CLICK_CHARGE_PER_MONTH_EXCL_GST:
    "SET_QUOTE_CFA_CC_BW_ADJUST_CLICK_CHARGE_PER_MONTH_EXCL_GST",
  SET_QUOTE_CFA_CC_BW_MINIMUM_MONTHLY_CLICK_VOLUME:
    "SET_QUOTE_CFA_CC_BW_MINIMUM_MONTHLY_CLICK_VOLUME",
  SET_QUOTE_CFA_CC_BW_SERVICE_COPY_COST:
    "SET_QUOTE_CFA_CC_BW_SERVICE_COPY_COST",
  SET_QUOTE_CFA_CC_BW_EXCESS_FINANCED_COPY_COST:
    "SET_QUOTE_CFA_CC_BW_EXCESS_FINANCED_COPY_COST",
  SET_QUOTE_CFA_CC_COLOUR: "SET_QUOTE_CFA_CC_COLOUR",
  SET_QUOTE_CFA_CC_COLOUR_ADJUST_CLICK_CHARGE_PER_MONTH_EXCL_GST:
    "SET_QUOTE_CFA_CC_COLOUR_ADJUST_CLICK_CHARGE_PER_MONTH_EXCL_GST",
  SET_QUOTE_CFA_CC_COLOUR_MINIMUM_MONTHLY_CLICK_VOLUME:
    "SET_QUOTE_CFA_CC_COLOUR_MINIMUM_MONTHLY_CLICK_VOLUME",
  SET_QUOTE_CFA_CC_COLOUR_SERVICE_COPY_COST:
    "SET_QUOTE_CFA_CC_COLOUR_SERVICE_COPY_COST",
  SET_QUOTE_CFA_CC_COLOUR_EXCESS_FINANCED_COPY_COST:
    "SET_QUOTE_CFA_CC_COLOUR_EXCESS_FINANCED_COPY_COST",
  SET_QUOTE_FINANCE_TERM: "SET_QUOTE_FINANCE_TERM",
  SET_QUOTE_INSTALMENT_AMOUNT: "SET_QUOTE_INSTALMENT_AMOUNT",
  SET_QUOTE_INSTALMENT_TYPE: "SET_QUOTE_INSTALMENT_TYPE",
  SET_QUOTE_MIN_MONTHLY_CLICK_VOLUME_COLOUR:
    "SET_QUOTE_MIN_MONTHLY_CLICK_VOLUME_COLOUR",
  SET_QUOTE_ORIGINATOR_REFERENCE: "SET_QUOTE_ORIGINATOR_REFERENCE",
  SET_QUOTE_PAYABLE_IN: "SET_QUOTE_PAYABLE_IN",
  SET_QUOTE_RESIDUAL_VALUE: "SET_QUOTE_RESIDUAL_VALUE",
  SET_QUOTE_THIRD_PARTY_PAYOUT: "SET_QUOTE_THIRD_PARTY_PAYOUT",
  SET_QUOTE_FINANCE_DEFERRED_PAYMENT: "SET_QUOTE_FINANCE_DEFERRED_PAYMENT",
  SET_QUOTE_TONER_RECYCLE_BOX: "SET_QUOTE_TONER_RECYCLE_BOX",
  SET_QUOTE_PAYOUT_INFO: "SET_QUOTE_PAYOUT_INFO",
  INSTALMENT_TYPE_MONTHLY: "MONTHLY",
  // endregion

  SET_QUOTE_SOFTWARE_DELIVERY_ADDRESS_ID:
    "SET_QUOTE_SOFTWARE_DELIVERY_ADDRESS_ID",
  SET_QUOTE_SOFTWARE_INSTALLATION_ADDRESS_ID:
    "SET_QUOTE_SOFTWARE_INSTALLATION_ADDRESS_ID",
  SET_QUOTE_CUSTOMER_BILLING_ADDRESS_ID:
    "SET_QUOTE_CUSTOMER_BILLING_ADDRESS_ID",

  SET_QUOTE_SAAS_DELIVERY_ADDRESS_ID: "SET_QUOTE_SAAS_DELIVERY_ADDRESS_ID",
  SET_QUOTE_SAAS_INSTALLATION_ADDRESS_ID:
    "SET_QUOTE_SAAS_INSTALLATION_ADDRESS_ID",

  SET_QUOTE_SAME_SOFTWARE_INSTALL_DELIVERY_ADDRESS:
    "SET_QUOTE_SAME_SOFTWARE_INSTALL_DELIVERY_ADDRESS",
  SET_QUOTE_SAME_SAAS_INSTALL_DELIVERY_ADDRESS:
    "SET_QUOTE_SAME_SAAS_INSTALL_DELIVERY_ADDRESS",

  ADD_QUOTE_ITEM: "ADD_ITEM_TO_QUOTE",
  DELETE_QUOTE_ITEM: "DELETE_ITEM_FROM_QUOTE",
  SET_QUOTE_ITEM: "UPDATE_ITEM_IN_QUOTE",

  SET_QUOTE_ITEM_VALIDATION_MAP: "SET_QUOTE_ITEM_VALIDATION_MAP",

  SET_QUOTE_BACKEND_VALIDATION_MESSAGES:
    "SET_QUOTE_BACKEND_VALIDATION_MESSAGES",
  SET_QUOTE_BACKEND_VALIDATION_IN_PROGRESS:
    "SET_QUOTE_BACKEND_VALIDATION_IN_PROGRESS"
  // endregion
};
